import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "f16b0t3IQZPA4p9KmWI9fMS", "Win", undefined);

import { _decorator, Component, Node, tween, v3, Label, Sprite } from 'cc';
import ScaleAct from './common/actionItem/ScaleAct';
import { E_ADUrl } from './common/ad/AdCtr';
import { E_ADEventType, E_AdType, E_EventType, E_MainLayerType, E_PlatformType, E_ResPath, NodeInWindow_Pos } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_PoolType } from './common/manager/PoolManager';
import { E_MusicType, E_SoundType } from './common/manager/SoundManager';
import { LinkOut } from './LinkOut';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Win = (_dec = ccclass('Win'), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Node), _dec5 = property(Label), _dec6 = property(Label), _dec7 = property(Label), _dec8 = property(Node), _dec9 = property(Node), _dec10 = property(Node), _dec11 = property(Node), _dec12 = property(Node), _dec13 = property(Node), _dec14 = property(Node), _dec15 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Win, _Component);

  function Win() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_bg", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_lvBg", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_chapterTip", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_coin", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_coinAd", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_tgLv", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_curTgIcon", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_nextTgIcon", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_pg", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_star", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_coinGain", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ad", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_home", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_logo", _descriptor14, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_coinGain", 0);

    _defineProperty(_assertThisInitialized(_this), "_nodeArr", []);

    return _this;
  }

  var _proto = Win.prototype;

  _proto.onLoad = function onLoad() {
    this._nodeArr = [this.n_lvBg, this.n_chapterTip, this.n_star, this.n_coinGain, this.n_ad, this.n_home];
    App.CommonAmn.recordInitPosArr(this._nodeArr);
    App.CommonAmn.recordExitPosByType(this.n_chapterTip, NodeInWindow_Pos.Right);
    App.CommonAmn.recordExitPosByType(this.n_star, NodeInWindow_Pos.Right);
    App.CommonAmn.recordExitPosByType(this.n_coinGain, NodeInWindow_Pos.Right);
    App.CommonAmn.recordExitPosByType(this.n_ad, NodeInWindow_Pos.Left);
    App.CommonAmn.recordExitPosByType(this.n_home, NodeInWindow_Pos.Left);
  };

  _proto.start = function start() {
    // [3]
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
    this.addEventListener();
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListener = function addEventListener() {
    App.AdEventMgr.addEventLintener(E_ADEventType.video_showOver, this.handle_adSucc, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.AdEventMgr.removeEvent(this);
  };

  _proto.handle_adSucc = function handle_adSucc() {
    if (App.AdCtrl.type == E_AdType.Win) {
      App.DataMgr.coin += this._coinGain * 2;
      App.GameCtrl.flyAmn(E_PoolType.Coin, this.n_ad.worldPosition, App.GameCtrl.n_coinRoot.worldPosition);
      this.exit();
    }
  };

  _proto.enter = function enter() {
    var _this2 = this;

    this.n_logo.active = App.AdCtrl.platformType != E_PlatformType.XiaoMi;
    App.GameCtrl.gameTims++;
    App.SoundMgr.stopMusic();
    App.SoundMgr.playEffectType(E_SoundType.Win);
    this.actLvBg(v3(1, 0, 1), v3(1, 1, 1));
    App.CommonAmn.act_fade(this.n_bg, 0, 0.5, 0, 160);
    App.CommonAmn.act_dir2Init_node(this.n_chapterTip, NodeInWindow_Pos.Left, 0, 0.25, "backOut");
    App.CommonAmn.act_dir2Init_node(this.n_star, NodeInWindow_Pos.Left, 0.15, 0.25, "backOut");
    App.CommonAmn.act_dir2Init_node(this.n_coinGain, NodeInWindow_Pos.Left, 0.3, 0.25, "backOut");
    App.CommonAmn.act_dir2Init_node(this.n_ad, NodeInWindow_Pos.Right, 0, 0.25, "backOut");
    App.CommonAmn.act_dir2Init_node(this.n_home, NodeInWindow_Pos.Right, 0.3, 0.25, "backOut", function () {
      _this2.n_ad.getComponent(ScaleAct).act(); //飞金币


      App.GameCtrl.flyAmn(E_PoolType.Coin, _this2.n_coinGain.worldPosition, App.GameCtrl.n_coinRoot.worldPosition);
    }); //星星

    var starNum = 1;

    if (App.DataMgr.tollgateLv < 5) {
      starNum = 3;
    } else {
      if (App.GameCtrl.score > 50) {
        starNum++;
      }

      if (App.GameCtrl.t_run <= App.DataMgr.mapLen / 10) {
        starNum++;
      }
    }

    this.actStar(starNum); //金币

    var coinGain = App.NumHandler.round_int(20, 40);
    coinGain += starNum * App.NumHandler.round_int(10, 10);
    this._coinGain = coinGain;
    this.lbl_coin.string = this._coinGain + "";
    this.lbl_coinAd.string = this._coinGain * 2 + "";
    App.DataMgr.coin += this._coinGain; //关卡等级

    this.lbl_tgLv.string = "LEVEL " + (App.DataMgr.tollgateLv + 1) + "\nCOMPLETED!"; //关卡进度

    var curLv = App.DataMgr.tollgateLv;
    var num_pg = curLv % 5;

    for (var i = 0; i <= 4; i++) {
      this.n_pg.children[i].active = i <= num_pg;
    } //章节图标


    var c_now = Math.floor(App.DataMgr.tollgateLv / 5);
    var c_next = c_now + 1;
    if (c_next > 4) c_next = 0;
    App.ResMgr.loadSf(this.n_curTgIcon.getComponent(Sprite), E_ResPath.Tex_ChapterIcon + "icon_" + c_now);
    App.ResMgr.loadSf(this.n_nextTgIcon.getComponent(Sprite), E_ResPath.Tex_ChapterIcon + "icon_" + c_next);
    App.GameCtrl.n_link.getComponent(LinkOut).enter();

    if (App.AdCtrl.platformType != E_PlatformType.Normal) {
      App.AdCtrl.type = E_AdType.None;
      App.AdCtrl.showRewardedVideoAd();
    }
  };

  _proto.actStar = function actStar(starNum) {
    for (var i = 0; i < 3; i++) {
      this.n_star.children[i].children[0].active = false;
    }

    for (var _i = 0; _i < starNum; _i++) {
      this.actStar_single(this.n_star.children[_i].children[0], _i);
    }
  };

  _proto.actStar_single = function actStar_single(n_str, index) {
    n_str.setPosition(v3(-300, 300, 0));
    tween(n_str).delay(index * 0.35 + 1).call(function () {
      n_str.active = true;
    }).to(0.35, {
      position: v3(0, 0, 0)
    }).start();
  };

  _proto.actLvBg = function actLvBg(initScale, aimScale) {
    this.n_lvBg.scale = initScale;
    tween(this.n_lvBg).to(0.5, {
      scale: aimScale
    }, {
      easing: "backOut"
    }).start();
  };

  _proto.exit = function exit() {
    App.DataMgr.tollgateLv++;
    App.EventMgr.handleEvent(E_EventType.Lv_Up);
    App.GameCtrl.isSwitch = true;
    this.actLvBg(v3(1, 1, 1), v3(1, 0, 1));
    App.CommonAmn.act_fade(this.n_bg, 0, 0.5, 160, 0);
    App.CommonAmn.act_exit(this.n_chapterTip, 0, 0.25, "backIn");
    App.CommonAmn.act_exit(this.n_star, 0.15, 0.25, "backIn");
    App.CommonAmn.act_exit(this.n_coinGain, 0.3, 0.25, "backIn");
    App.CommonAmn.act_exit(this.n_ad, 0, 0.25, "backIn");
    App.CommonAmn.act_exit(this.n_home, 0.3, 0.25, "backIn", function () {
      App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Hall);
      App.GameCtrl.isSwitch = false;
      App.SoundMgr.playMusicType(E_MusicType.Hall);
      App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Gift);
    });
    App.GameCtrl.n_link.getComponent(LinkOut).exit();
  };

  _proto.btn_event = function btn_event(btn) {
    switch (btn.node.name) {
      case "n_ad":
        // App.GameCtrl.isSwitch = true;
        App.AdCtrl.type = E_AdType.Win;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "n_home":
        this.exit();
        break;

      case "n_logo":
        window.open(E_ADUrl.Dob5_URL, "_self");
        break;
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return Win;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_bg", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_lvBg", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_chapterTip", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "lbl_coin", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "lbl_coinAd", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "lbl_tgLv", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "n_curTgIcon", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "n_nextTgIcon", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "n_pg", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "n_star", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "n_coinGain", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "n_ad", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "n_home", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "n_logo", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();